import * as React from 'react';

const PythonIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M7.22794 3.96008C7.22794 2.07253 7.74565 1.04569 10.604 0.556722C12.5446 0.224187 15.0328 0.18262 17.3538 0.556722C19.1869 0.852539 20.7299 2.18753 20.7299 3.96008V10.1875C20.7299 12.0139 19.2319 13.5101 17.3538 13.5101H10.604C8.31324 13.5101 6.38257 15.4197 6.38257 17.5785V20.5663H4.06175C2.09863 20.5663 0.955646 19.1824 0.475495 17.246C-0.172171 14.6444 -0.144677 13.0944 0.475495 10.6029C1.01318 8.42935 2.73127 7.28252 4.69454 7.28252H13.9801V6.45118H7.2278L7.22794 3.96008Z"
            fill="url(#paint0_linear_781_1285)"
        />
        <path
            d="M20.73 23.889C20.73 25.7765 19.0545 26.7326 17.3539 27.2093C14.7956 27.9282 12.7423 27.8182 10.6042 27.2093C8.8185 26.7008 7.2281 25.6617 7.2281 23.889V17.6616C7.2281 15.8693 8.75614 14.339 10.6042 14.339H17.3539C19.6022 14.339 21.5754 12.4394 21.5754 10.1874V7.28273H24.1062C26.0719 7.28273 26.9974 8.71056 27.4823 10.6031C28.1575 13.2315 28.1875 15.1972 27.4823 17.2462C26.7997 19.2364 26.0694 20.5665 24.1062 20.5665H13.9803V21.3979H20.73V23.889Z"
            fill="url(#paint1_linear_781_1285)"
        />
        <path
            d="M8.91594 3.54689C8.91594 2.85743 9.48113 2.29988 10.1815 2.29988C10.8792 2.29988 11.4471 2.85729 11.4471 3.54689C11.4471 4.23413 10.8793 4.7914 10.1815 4.7914C9.48141 4.7914 8.91594 4.23399 8.91594 3.54689ZM16.5108 24.3023C16.5108 23.6151 17.0785 23.0578 17.7763 23.0578C18.4764 23.0578 19.0419 23.6152 19.0419 24.3023C19.0419 24.9918 18.4767 25.5493 17.7763 25.5493C17.0786 25.5493 16.5108 24.9919 16.5108 24.3023Z"
            fill="white"
        />
        <defs>
            <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint0_linear_781_1285"
                x1="28.0002"
                x2="0.000295679"
                y1="10.9496"
                y2="10.7222"
            >
                <stop stopColor="#366A96" />
                <stop offset="1" stopColor="#3679B0" />
            </linearGradient>
            <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint1_linear_781_1285"
                x1="27.9998"
                x2="-27.3144"
                y1="13.9998"
                y2="13.9998"
            >
                <stop stopColor="#FFC836" />
                <stop offset="1" stopColor="#FFE873" />
            </linearGradient>
        </defs>
    </svg>
);
export default PythonIcon;
